/**
 * Generates a racecard and attachs DOM event methods
 *
 * @module app/views/RacecardResultsViewProvider
 */
import _ from 'lodash';
import RacecardResultGHTemplate from './templates/racecards/RacecardResultGH';
import RacecardResultHRTemplate from './templates/racecards/RacecardResultHR';
import RacecardResultMMTemplate from './templates/racecards/RacecardResultMM';
import Translator from '../components/Translator';

/**
 * HR Racecard result compiled template
 *
 * @type {Function}
 *
 * @private
 */
var compiledRacecardResultHRTemplate = _.template(RacecardResultHRTemplate);

/**
 * GH Racecard result compiled template
 *
 * @type {Function}
 *
 * @private
 */
var compiledRacecardResultGHTemplate = _.template(RacecardResultGHTemplate);

/**
 * MM Racecard result compiled template
 *
 * @type {Function}
 *
 * @private
 */
var compiledRacecardResultMMTemplate = _.template(RacecardResultMMTemplate);

var renders = {

    /**
     * Renders a Horseracing template
     *
     * @params {Object} OB/PDS data
     *
     * @returns {string} parsed template
     *
     * @private
     */
    HR: function (data) {

        var isQuantumLeapCompetition = window.WH.sportsbook.frontEndConfig.qlCompetitions.includes(data.competitionId);

        var extendedData = _.extend({
            silkImageBaseURL: isQuantumLeapCompetition ? window.WH.sportsbook.frontEndConfig.qlSilkImageBaseUrl
                : window.WH.sportsbook.frontEndConfig.silkImageBaseURL,
            isQuantumLeapCompetition: isQuantumLeapCompetition,
        }, data);

        return compiledRacecardResultHRTemplate({
            data: extendedData,
        });
    },

    /**
     * Renders a Greyhound template
     *
     * @params {Object} OB/PDS data
     *
     * @returns {string} parsed template
     *
     * @private
     */
    GH: function (data) {

        return compiledRacecardResultGHTemplate({
            data: data,
        });
    },

    /**
     * Renders a Meetings Page template
     *
     * @params {Object} OB/PDS data
     *
     * @returns {string} parsed template
     *
     * @private
     */
    MM: function (data) {

        return compiledRacecardResultMMTemplate({
            data: data,
            translator: Translator,
        });
    },
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {

    /**
     * Generates a type code based on the page and whether its a meeting market
     *
     * @params {Object} identifiers to determine template code
     *
     * @returns {string} type code (HR, GH, MM)
     *
     * @public
     */
    getTypeCode: function (o) {

        if (o.isMeetingMarket) {
            return 'MM';
        }

        var encodedSportTemplateCode = function () {

            return o.isHorse ? 'HR' : 'GH';
        };

        return encodedSportTemplateCode();
    },

    /**
     * Render's a racecard result into a DOM element
     *
     * @param {String} type code (HR, GH, MM).
     * @param {Object} dom element to replace content
     * @param {Object} data to parse in. Mostly OB but will be argmented with PDS.
     *
     * @returns {void}
     *
     * @public
     */

    render: function (typeCode, element, data) {

        element.innerHTML = renders[typeCode](data);
    },

};

export default api;
